import React from 'react'
import { StackView } from '@planningcenter/tapestry-react'
import { Link, List, PageHeading, Text } from '../../../shared/typography'

const page = () => {
  return (
    <StackView axis="vertical" spacing={2}>
      <PageHeading>Add-ons Process</PageHeading>

      <List ordered>
        <List.Item>
          <Text>
            <b>Say hi.</b> Reach out to express interest in building an add-on
            by filling out{' '}
            <Link
              to="https://form.asana.com/?k=mHim-98ugkqphj8UIOCkpw&d=1202585680506197"
              external
            >
              this form
            </Link>
            . Please know we get lots of interest but can only work with a few
            partners. If an add-on for your product is something we want to
            pursue, we will reach out to you.
          </Text>
        </List.Item>

        <List.Item>
          <Text>
            <b>Get the contracts signed.</b> We have agreements that need to be
            in place to protect both parties.
          </Text>
        </List.Item>

        <List.Item>
          <Text>
            <b>Kickoff call.</b> Your development team will meet with our
            development team over Zoom to get things started. We’ll set up your
            developer account for add-on development and invite you to a shared
            Slack channel where we can easily support you while you work.
          </Text>
        </List.Item>

        <List.Item>
          <Text>
            <b>Build it!</b> This part’s up to you, but we want to be involved
            as much as is helpful here! Please don’t hesitate to use that Slack
            channel to ask questions, verify assumptions, or make feature
            requests. We want to make the development process as seamless as
            possible.
          </Text>
        </List.Item>

        <List.Item>
          <Text>
            <b>Beta.</b> You should find some of your users who are interested
            in the add-on to try it out. We don’t have a hard and fast rule for
            the amount of time or number of users that the add-on should be in
            beta -- we just want you to be confident that it works well.
          </Text>
        </List.Item>

        <List.Item>
          <Text>
            <b>Final review.</b> Before a wide release, we like to do one last
            check-in with our team and yours to see if there’s any rough edges
            we’d like to see smoothed before launching the add-on.
          </Text>
        </List.Item>

        <List.Item>
          <Text>
            <b>Wide release.</b> We’ll work together to decide upon timing for a
            wide release and marketing push.
          </Text>
        </List.Item>

        <List.Item>
          <Text>
            <b>Iterate.</b> If you want to make changes or add new features to
            the add-on, go for it! The staging and beta environments are here to
            help make that easier for you. No need for us to review every change
            you make, but we do like to hear about them, mostly just to
            celebrate with you.
          </Text>
        </List.Item>
      </List>
    </StackView>
  )
}

export default page
